/**
 * Sistema de indicação (voucher) no link de venda direta.
 *
 * A marca liga ou desliga o sistema no próprio cadastro, e a API expõe a
 * escolha em GET /busca-uuid como `sistema_indicacao` (para a Contel o valor
 * é sempre `true`). Com o sistema desligado, o fluxo inteiro do voucher sai:
 * o campo "Tenho um código", a validação automática de `?indicacao=`, o card
 * de convite e o envio de `codigo_indicacao` no pedido.
 *
 * Fica aqui, e não nos componentes, porque a decisão é da marca e o link de
 * venda direta não pode ter lógica de MVNO dentro de componente React (ver
 * CLAUDE.md).
 */

/**
 * Normaliza o campo vindo da API.
 *
 * Só o booleano `true` liga. A ausência do campo, `null` ou qualquer outro
 * valor desliga de propósito: um voucher de indicação gera benefício para
 * quem indicou, então na dúvida o sistema fica fora do ar.
 */
export function normalizeReferralVoucherEnabled(value: unknown): boolean {
  return value === true
}

export interface ReferralCodeInput {
  isVoucherValid: boolean
  referralVoucherEnabled: boolean
}

/**
 * Se o pedido leva `codigo_indicacao`. Um voucher validado não basta: a marca
 * precisa estar com o sistema de indicação ligado.
 */
export function shouldSendReferralCode({
  isVoucherValid,
  referralVoucherEnabled,
}: ReferralCodeInput): boolean {
  return isVoucherValid && referralVoucherEnabled
}
